export default function (array, n, predicate) {
  var results = []

  var i = 0
  while (i < array.length && results.length < n) {
    var v = array[i]
    if (predicate(v)) {
      results.push(v)
      array.splice(i, 1)
    } else {
      i++
    }
  }

  return results
}
